import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, Radio } from '@material-ui/core'
import TextField from './TextField'
import { handleFormValueChange } from 'actions/signupForm/addOrEdit'
import { toggleCustomLandingPage } from 'actions/customForm/addOrEdit'
import EditorNext from 'components/EditorNext'
import Button from 'components/theme/Button'
import AceEditor from 'react-ace'
import pretty from 'pretty'
import 'brace/mode/html'
import 'brace/theme/monokai'

const LandingPageEditor = connect(
	(state) => ({
		landingPageContent:
			state.signupForm.addOrEdit.values?.landingPageContent?.value || '',
	}),
	(dispatch) => bindActionCreators({ handleFormValueChange }, dispatch),
)(({ landingPageContent, handleFormValueChange, codeEditorDisplayed }) =>
	codeEditorDisplayed ? (
		<AceEditor
			// className="ignore-react-onclickoutside"
			width="100%"
			mode="html"
			theme="monokai"
			name="blah2"
			onChange={(value) => handleFormValueChange('landingPageContent', value)}
			fontSize={12}
			showPrintMargin={true}
			wrapEnabled={true}
			showGutter={true}
			highlightActiveLine={true}
			value={pretty(landingPageContent || '')}
			setOptions={{
				showLineNumbers: true,
				tabSize: 2,
			}}
			debounceChangePeriod={1500}
			height="350px"
		/>
	) : (
		<EditorNext
			noMergeFields
			contentHeight={300}
			onChange={(value) => handleFormValueChange('landingPageContent', value)}
			value={landingPageContent}
		/>
	),
)

const LandingPage = ({
	editorDisplayed,
	toggleCustomLandingPage,
	fullScreen,
}) => {
	// const [editorDisplayed, toggleEditor] = useState(true)
	const [codeEditorDisplayed, setDisplay] = useState(false)

	return (
		<Grid container style={{ backgroundColor: '#fff' }}>
			<Grid item xs="12">
				{/* <span>Customize Landing Page</span>
					<span>
						<Switch
							checked={!editorDisplayed}
							onChange={() => toggleEditor(!editorDisplayed)}
						/>
					</span>
					<span>Redirect to another URL</span> */}
				<div style={{ display: 'inline-block' }}>
					<Radio
						checked={editorDisplayed}
						onChange={() => toggleCustomLandingPage(true)}
					/>{' '}
					Customize Landing Page
				</div>
				<div style={{ display: 'inline-block' }}>
					<Radio
						checked={!editorDisplayed}
						onChange={() => toggleCustomLandingPage(false)}
					/>{' '}
					Redirect to another URL
				</div>
			</Grid>
			{editorDisplayed ? (
				<Grid item xs="12">
					<div
					// style={{ height: 'calc(100% - 166.5px', overflow: 'hidden' }}
					>
						{<LandingPageEditor codeEditorDisplayed={codeEditorDisplayed} />}
					</div>
					<div style={{ textAlign: 'left', width: '100%' }}>
						<Button
							style={{ marginTop: 10 }}
							onClick={() => setDisplay(!codeEditorDisplayed)}
						>
							Edit {codeEditorDisplayed ? 'content' : 'code'}
						</Button>
					</div>
				</Grid>
			) : (
				<Grid item xs="12">
					<TextField property="landingPageURL" label="Redirect URL" />
				</Grid>
			)}
		</Grid>
	)
}

export default connect(
	(state) => ({
		editorDisplayed: state.signupForm.addOrEdit.customLandingPage,
	}),
	(dispatch) => bindActionCreators({ toggleCustomLandingPage }, dispatch),
)(LandingPage)
